export enum SubscriptionType {
  CalendarIntegration = 'calendar-integration',
  PersonalEmailIntegration = 'personal-email-integration',
  SharedEmailIntegration = 'shared-email-integration',
}
